import React from 'react';
import styled from 'styled-components';

const RatingsContainer = styled.section`
  text-align: center;
  padding: 4rem 0;
  background: linear-gradient(-90deg, #2e2e2e 1%, #000 80%);
  color: #FFFFFF;
`;

const RatingsTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: white;
`;

const StarsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

const StarWrapper = styled.div`
  position: relative;
  width: 2rem;
  height: 2rem;
  margin: 0 0.2rem;
`;

const StarIcon = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  color: #ffe955;
  font-size: 2rem;
`;

const RatingsText = styled.p`
  font-size: 1rem;
  color: #FFFFFF;
`;

const Star = ({ filled, half }) => {
  return (
    <StarWrapper>
      <StarIcon style={{ clipPath: half ? 'inset(0 50% 0 0)' : 'none' }}>★</StarIcon>
      {!filled && <StarIcon>☆</StarIcon>}
    </StarWrapper>
  );
};

const RatingsSection = () => {
  const totalStars = 5;
  const rating = 4.5;

  return (
    <RatingsContainer>
      <RatingsTitle>Join the hundreds of satisfied creators who love our tool</RatingsTitle>
      <StarsContainer>
        {[...Array(totalStars)].map((_, index) => (
          <Star
            key={index}
            filled={index < Math.floor(rating)}
            half={index === Math.floor(rating) && rating % 1 !== 0}
          />
        ))}
      </StarsContainer>
      <RatingsText>4.7/5 average from 577 ratings</RatingsText>
    </RatingsContainer>
  );
};

export default RatingsSection;